'use strict';

/**
 * PDP Sticky CTA Section
 * Shows the bar once the buybox scrolls out of view; the button scrolls back to it.
 */
if (!customElements.get('pdp-sticky-cta')) {
  class PdpStickyCta extends HTMLElement {
    constructor() {
      super();
      this.onButtonClick = this.onButtonClick.bind(this);
      this.onIntersect = this.onIntersect.bind(this);
      this.onSectionSelect = this.onSectionSelect.bind(this);
      this.onSectionDeselect = this.onSectionDeselect.bind(this);
    }

    connectedCallback() {
      this.button = this.querySelector('.pdp-sticky-cta__button');
      this.buybox = this.resolveBuybox();

      this.button?.addEventListener('click', this.onButtonClick);

      if (this.buybox) {
        this.observer = new IntersectionObserver(this.onIntersect);
        this.observer.observe(this.buybox);
      } else {
        this.toggle(true);
      }

      if (window.Shopify?.designMode) {
        document.addEventListener('shopify:section:select', this.onSectionSelect);
        document.addEventListener('shopify:section:deselect', this.onSectionDeselect);
      }
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.onButtonClick);
      this.observer?.disconnect();
      document.removeEventListener('shopify:section:select', this.onSectionSelect);
      document.removeEventListener('shopify:section:deselect', this.onSectionDeselect);
    }

    resolveBuybox() {
      const selector = this.dataset.buyboxSelector || '.mpv1';

      try {
        const target = document.querySelector(selector);
        if (target) return target;
      } catch {
        // Invalid selector configured in the theme editor - fall through to the form fallback.
      }

      return document.querySelector('form[action*="/cart/add"]')?.closest('.shopify-section') ?? null;
    }

    onIntersect(entries) {
      if (this.selectedInEditor) return;

      const entry = entries[0];
      const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      this.toggle(scrolledPast);
    }

    onButtonClick() {
      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

      if (this.buybox) {
        this.buybox.scrollIntoView({ behavior, block: 'start' });
      } else {
        window.scrollTo({ top: 0, behavior });
      }
    }

    onSectionSelect(event) {
      if (!event.target.contains(this)) return;
      this.selectedInEditor = true;
      this.toggle(true);
    }

    onSectionDeselect(event) {
      if (!event.target.contains(this)) return;
      this.selectedInEditor = false;
      this.toggle(false);
    }

    toggle(visible) {
      this.classList.toggle('is-visible', visible);
      this.setAttribute('aria-hidden', String(!visible));
    }
  }

  customElements.define('pdp-sticky-cta', PdpStickyCta);
}
